import ResourceImage from '../../ResourceImage/ResourceImage';
import T, { Translate } from '../../i18n/i18n';
import { TableItemCell, TableItemName, TableItemLabel, TableItemInfo, TableImage, TableItemContent, Empty } from './TableItem.styles';

const getTags = (tags, Translate) => {
    if (!tags || tags.length === 0) {
        return null;
    }
    let t = "";
    let end = "";

    if (tags.length >= 1) {
        t = tags[0][Translate("lang")];
    }
    if (tags.length > 2) {
        end = Translate("findtables.more").replace("$1", tags.length - 1);
    }
    if (tags.length === 2) {
        end = Translate("and") + tags[1][Translate("lang")];
    }

    return t + " " + end;

    
};

export default ({onOpen, table, className}) => {

    const handleOpen = () => {
        if (typeof onOpen === 'function') {
            onOpen(table);
        }
    }

    return !table ? null : <TableItemCell onClick={handleOpen} className={className ?? 'full'}>
        <TableImage>
            {table.thumbnail ? <ResourceImage resourceId={table.thumbnail} /> : null}
        </TableImage>
        <TableItemContent>
            <TableItemInfo>
                <TableItemName className='text'>{table.name || <Empty><T value='tables.noNameDefined' /></Empty>}</TableItemName>
                <TableItemLabel><span className="mdi mdi-calendar mdi-18px"></span> {table.nextEncounter || <Empty><T value='tables.noNextDefined' /></Empty>}</TableItemLabel>
                <TableItemLabel><span className="mdi mdi-account-multiple mdi-18px"></span> {table.currentPlayers || '0'} <T value={`tables.player${table.currentPlayers === 1 ? '' : 's'}`} /></TableItemLabel>
            </TableItemInfo>
            <TableItemInfo>
                <TableItemLabel><span className="mdi mdi-dice-multiple mdi-18px"></span> {table.charsheetTemplate || <Empty><T value='tables.noSytemDefined' /></Empty>}</TableItemLabel>
                <TableItemLabel><span className="mdi mdi-crown mdi-18px"></span> {table.owner || <Empty><T value='tables.noOwnerDefined' /></Empty>}</TableItemLabel>
                <TableItemLabel><span className="mdi mdi-tag mdi-18px"></span> {getTags(table.content, Translate) ?? <Empty><T value='tables.noContentDefined' /></Empty>}</TableItemLabel>
                <TableItemLabel><span className="mdi mdi-monitor-cellphone mdi-18px"></span> {getTags(table.tools, Translate) ?? <Empty><T value='tables.noToolsDefined' /></Empty>}</TableItemLabel>
            </TableItemInfo>
        </TableItemContent>
    </TableItemCell>
};